exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login {\n    width: 350px;\n    background-color: rgba(255,89,90,) 0,7;\n    padding: 20px 25px 30px;\n    margin: 0 auto;\n    top: 50%;\n    transform: translateY(50%);\n}\n\n.login-logo {\n    width: 80px;\n    height: 80px;\n    margin: 0 auto 20px;\n    display: block;\n}\n.login-form input[type=email],\n.login-form input[type=password],\n.login-form input[type=text],\n.login-form button {\n    width: 100%;\n    display: block;\n    margin-bottom: 10px;\n}\n.form-control {\n    display: block;\n    width: 100%;\n    height: 34px;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    color: #FF595A;\n    background-color: #FFFFFF;\n    border: 1px solid #011E41 (0,8); \n    border-radius: 4px;\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n}\n.form-control:focus {\n  border-color: #FF595A .1;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px #FF595A;\n}\n.form-control:active {\nborder-color:#cfc4c5 (0,2);\noutline: 0;\nbox-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px#cfc4c5;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main